<div class="modal-header">
  <h5 class="modal-title">Editar Parámetro</h5>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12 mb-3">
        <app-cbb-field label="Nombre (Clave)" type="text" formControlName="name"></app-cbb-field>
        <small class="text-muted">El nombre es la clave del sistema y no se puede editar.</small>
      </div>

      <div class="col-12 mb-3">
        <app-cbb-field label="Valor" type="text" formControlName="value"></app-cbb-field>
      </div>

      <div class="col-12">
        <label class="form-label" style="font-size: 0.85rem; font-weight: 600; color: var(--color-text-body); margin-bottom: 0.5rem;">
            Descripción
        </label>
        <textarea 
            class="form-control" 
            formControlName="description" 
            rows="3"
            style="border-radius: 8px; border: 1px solid var(--cbb-gray-200); font-size: 0.9rem;"
        ></textarea>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer border-top-0 pt-0 mt-3">
  <app-cbb-button variant="outline" (click)="close()">Cancelar</app-cbb-button>
  <app-cbb-button [disabled]="form.invalid" (click)="save()">Guardar Cambios</app-cbb-button>
</div>
